import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { APP_NAME } from '@/config/env'
import { findNavLeaf } from '../navigation'
import { Header } from './Header'
import { Sidebar } from './Sidebar'

const COLLAPSE_KEY = 'woctools-sidebar-collapsed'

function readCollapsed(): boolean {
  try {
    return window.localStorage.getItem(COLLAPSE_KEY) === 'true'
  } catch {
    return false
  }
}

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(readCollapsed)
  const [mobileOpen, setMobileOpen] = useState(false)
  const { pathname } = useLocation()
  const match = findNavLeaf(pathname)
  const title = match?.leaf.label ?? APP_NAME

  useEffect(() => {
    try {
      window.localStorage.setItem(COLLAPSE_KEY, String(collapsed))
    } catch {
      // Preferência não persistida.
    }
  }, [collapsed])

  useEffect(() => {
    setMobileOpen(false)
  }, [pathname])

  useEffect(() => {
    document.title = match ? `${match.leaf.label} · ${APP_NAME}` : APP_NAME
  }, [match])

  return (
    <div className="flex h-full bg-card">
      <Sidebar
        collapsed={collapsed}
        onToggleCollapsed={() => setCollapsed((value) => !value)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header title={title} onOpenMobileMenu={() => setMobileOpen(true)} />
        {/* Conteúdo como painel sobre a moldura (menu + topo): contraste de superfície, sem linhas. */}
        <main
          id="conteudo"
          className="flex-1 overflow-y-auto bg-background lg:rounded-tl-[1.25rem] lg:shadow-[inset_1px_1px_0_hsl(var(--primary-text)/0.08)]"
          tabIndex={-1}
        >
          <div className="mx-auto w-full max-w-[100rem] space-y-5 p-4 lg:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
